import OpenApp from '@tencent/vft-common/openapp/index';
import { getSearchObj, asyncLoadJs } from '@tencent/magic-ui-util';

const isSportsEnv = () => typeof navigator !== 'undefined' && navigator.userAgent.includes('com.tencent.sportskbs');

const isAndroid = () => {
  if (window.magicApp) return Promise.resolve(window.magicApp.env?.isAndroid);
  // 如果在组件的created里面直接调用openUrl, 此时window.magicApp为undefined,需要异步获取
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(window.magicApp.env?.isAndroid);
    }, 0);
  });
};

let JSAPIReady = null;

if (isSportsEnv()) {
  // 加载JSAPI
  JSAPIReady = asyncLoadJs('//mat1.gtimg.com/sports/sportAppWeb/tua-app-sdk/tua-sports-bridge.js');
}


const getJumpData = (targetUrl) => {
  // 把scheme url转换为jumpData, pageType -> type, 其它参数放在param中
  const { pageType: type, ...param } = getSearchObj(new URL(targetUrl).search.substring(1));
  if (param.url) {
    param.url = decodeURIComponent(param.url);
  }
  return { type, param };
};

const download = (targetUrl) => {
  // 跳转下载页去下载,腾讯体育提供的页面
  location.href = `https://sports.qq.com/kbs/m.htm?jumpData=${encodeURIComponent(JSON.stringify(getJumpData(targetUrl)))}`;
};

async function launchOrDownload(schemaUrl) {
  // 微信手Q腾讯视频APP腾讯新闻天天快报APP内canGetInstallState为true，其他情况下canGetInstallState为false，走的是browser拉起APP的方式。
  if (OpenApp.canGetInstallState) {
    // 判断是否安装腾讯视频APP
    const packageName = (await isAndroid()) ? 'com.tencent.qqsports' : 'com.tencent.sportskbs';
    const packageUrl = 'qqsports://kbsqqsports?pageType=1&title=%E6%A0%87%E9%A2%98&url=http%3A%2F%2Fv.qq.com%3Fmid%3D111%26vid%3D222';
    if (await OpenApp.getInstallState({ packageName, packageUrl })) {
      // 安装则拉起
      const res = await OpenApp.launch(schemaUrl);
      console.log(res);
    } else {
      // 没有安装则跳转到应用宝下载地址或直接下载(腾讯新闻天天快报内)
      download(schemaUrl);
    }
  } else {
    // browser环境下直接尝试拉起APP
    if (await OpenApp.launch(schemaUrl)) {
      // 有安装
    } else {
      // 无安装
      download(schemaUrl);
    }
  }
}

const getSchemaUrl = (url) => {
  if (/^http[s]?:\/\//.test(url)) {
    return `qqsports://kbsqqsports?pageType=1&title=&url=${encodeURIComponent(url)}&from=H5`;
  }
  return url;
};

const launch = schemaUrl => launchOrDownload(getSchemaUrl(schemaUrl));

const openView = jumpData => JSAPIReady && JSAPIReady.then(() => {
  if (window.TencentSports) {
    // 此处可以调用 TencentSports 下的 API
    window.TencentSports.open?.(jumpData);
  }
});


export default (url) => {
  const schemaUrl = getSchemaUrl(url);
  if (isSportsEnv()) {
    return openView(getJumpData(schemaUrl));
  }
  return launch(schemaUrl);
};
